import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const saveSlotConfig = async ({ vehicleType, regionId, toTime, corporateId, file }) => {
  try {
    const formData = new FormData();
    formData.append('vehicleType', vehicleType);
    formData.append('regionId', regionId);
    formData.append('totime', toTime);
    formData.append('corporateId', corporateId);

    if (file) {
      formData.append('file', file);
    }

    const response = await api.post(API_END_POINTS.ADD_SLOTS, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const data = response.data;

    if (data.errorCode === 200) {
      return data.responseData;
    } else {
      throw new Error(data.errorMessage || 'Failed to save slot config');
    }
  } catch (error) {
    console.error('Error saving slot config:', error);
    throw error;
  }
};
